import React from 'react';

interface IProps {
  style?: any;
}

const ArtBoardIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M13.3628 6.17578H5.84961V13.6893H13.3628V6.17578ZM12.4754 12.8022H6.73697V7.06314H12.4754V12.8022Z" fill="#0F1318"/>
        <path d="M6.64837 4.01562H5.93848V5.67218H6.64837V4.01562Z" fill="#0F1318"/>
        <path d="M5.40557 6.26172H3.74902V6.97161H5.40557V6.26172Z" fill="#0F1318"/>
        <path d="M15.5355 6.26172H13.8789V6.97161H15.5355V6.26172Z" fill="#0F1318"/>
        <path d="M5.40557 12.8906H3.74902V13.6005H5.40557V12.8906Z" fill="#0F1318"/>
        <path d="M15.5355 12.8906H13.8789V13.6005H15.5355V12.8906Z" fill="#0F1318"/>
        <path d="M13.2739 4.01562H12.5645V5.67218H13.2739V4.01562Z" fill="#0F1318"/>
        <path d="M6.64837 14.1914H5.93848V15.8475H6.64837V14.1914Z" fill="#0F1318"/>
        <path d="M13.2739 14.1914H12.5645V15.8475H13.2739V14.1914Z" fill="#0F1318"/>
    </svg>
  )
}

export default ArtBoardIcon;